(function () {
  var aspectRatio = 4/4.5;

  function adjustImageHeight() {
    if($(window).width() > 991) {
      var productMediaItem = $(".main-product-page .product__media-list__container--large .product__media-item");
      var productMediaWidth = productMediaItem.width();
      var thisHeight = productMediaWidth / aspectRatio;
      productMediaItem.find(".product__media").css("max-height", thisHeight);
      // $(".main-product-page .product__media-list__container--large .product__media-item").each(function() {
      //   var thisWidth = $(this).width();
      //   var thisHeight = thisWidth / aspectRatio;
      //   $(this).find(".product__media").css("max-height", thisHeight);
      // })
    } else {
      $(".main-product-page .product__media-item").each(function() {
        var thisWidth = $(this).width();
        var thisHeight = thisWidth / aspectRatio;
        $(this).find(".product__media").css("max-height", thisHeight);
        $(this).parents(".product__media-list").css("max-height", thisHeight);
      })
    }
  }

  function showCustomerInfo(elem) {
    var elemTarget = $(elem).attr("data-collapse");
    var elemHeight = $(`#${elemTarget}`).find(".customer-info-collapsible-item-content").innerHeight();

    if($(`#${elemTarget}`).hasClass("active")) {
      $(`#${elemTarget}`).removeClass("active");
      $(`#${elemTarget}`).css("min-height", "0");
    } else {
      resetCustomerInfo();
      $(`#${elemTarget}`).addClass("active");
      $(`#${elemTarget}`).css("min-height", elemHeight);
    }

  }

  function resetCustomerInfo() {
    $(".customer-info-collapsible-item").css("min-height", "0");
    $(".customer-info-collapsible-item").removeClass("active");
  }

  adjustImageHeight();

  $(".customer-useful-info-item").on("click", function(){     
    showCustomerInfo($(this));
  });

  $(window).on('resize', function() {
    adjustImageHeight();
  });
})();